module.exports = __webpack_public_path__ + "static/media/LoadingScreen.06bdbdd4.gif";